import { AllEnvironmentName, EnvironmentName } from "waapi/environments-repository/constants/environments.js";
import { ENVIRONMENT_HOSTS } from "./constants.js";

export const getCurrentMystiqueEnv = (): AllEnvironmentName => {
    if (Reflect.has(ENVIRONMENT_HOSTS, window.location.host)) {
        return Reflect.get(ENVIRONMENT_HOSTS, window.location.host) ?? EnvironmentName.PROD;
    }

    return EnvironmentName.PROD;
};
